import rootReducer from "../../../store";
import {
  changeActiveTabs,
  setCertificateField,
  setCreateOrdersData,
  setCustomerData,
  setCustomerDropdown,
  setDetailsData,
  setDetailsFieldJson,
  setDoctorCategory,
  setGetAllOrderDocuments,
  setInsurerData,
  setInsurerDropdown,
  setInvoiceField,
  setIsCertificateFileChanged,
  setIsInvoiceFileChanged,
  setIsNewRenderer,
  setManualPaymentDetails,
  setOrderId,
  setOrderList,
  setPolicyData,
  setPolicyStatus,
  setProductAttributesData,
  setProductData,
  setProductDropdown,
  setProductFieldsJSON,
  setProductLayoutJSON,
  setProductVariant,
  setProductVariantEdit,
  setProductVariantModalState,
  setProductVariantState,
  setProposalFieldsJSON,
  setProposalJson,
  setProposalLayoutJSON,
  setProposalRulesJSON,
  setQualification,
  setRedirectUrl,
  setRmData,
  setRmName,
  setSelectedProductData,
  setSelectedProductInfo,
  setTransactionData,
} from "../../../slices/orders/orderSlice";
import {
  RenderPage,
  setPaginationTotalCount,
  setRendererFormState,
  setTableLoading,
  setTailSpinLoading,
  updateRendererFormState,
  updateRendererState,
} from "../../../slices/common/reducer";
import {
  applyUpdateOverrides,
  buildRenderViewModel,
} from "@craft-form/renderer";
import { showToast } from "../../../common/Toaster/Toaster";
import api from "../../../Utils/interface";
import { hoistNestedFiles } from "../../../Utils/craftFormFiles";
import { json } from "react-router-dom";
import { toast } from "react-toastify";
import { KYC_ALLOWED_OEM_IDS, formatKycStatus } from "./OrderUtils";

let debounceTimeout;
const debounce = (func, delay) => {
  return function (...arg) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => func.apply(this, arg), delay);
  };
};

export const getOrderList = debounce(async (status, date, code, params) => {
  const requestBody = {
    ...(status && { status: status }),
    ...(date.length === 2 && { from_date: date[0], to_date: date[1] }),
    ...(code !== undefined && code !== null && code !== "" && { code: code }),
  };
  try {
    // rootReducer.dispatch(setTailSpinLoading(true));

    const response = await api.post(
      `/agsp/order/getFilteredPspOrderList`,
      requestBody,
      {
        params: params,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.data) {
      rootReducer.dispatch(setOrderList(response.data.entity_list));
      rootReducer.dispatch(setPaginationTotalCount(response.data.total_count));
    }
    // rootReducer.dispatch(setTailSpinLoading(false));

    return response.data;
  } catch (error) {
    rootReducer.dispatch(setTailSpinLoading(false));
    console.log("error fetching order list", error);
  }
}, 500);


export const releaseOrder = (orderId) => {
  let fd = new FormData();
  fd.append("orderId", orderId);

  api
    .post(`agsp/order/release/${orderId}`, fd, {})
    .then((res) => {
      showToast("Order released successfully", "success");
      rootReducer.dispatch(RenderPage());
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};

export const getSendOrderLink = (orderId) => {
  api
    .get(`/agsp/order/sendOrderLink`, {
      params: {
        orderId: orderId,
      },
    })
    .then((res) => {
      if (res) {
        showToast("Order link send successfully", "success");
      }
      // rootReducer.dispatch(setRedirectUrl(res.data));
    })
    .catch((err) => {
      showToast(
        err.response?.data?.error_message || "An error occurred",
        "error",
      );
    });
};

export const getRedirectUrl = (orderId) => {
  api
    .get(`/agsp/order/generateOrderLink`, {
      params: {
        orderId: orderId,
      },
    })
    .then((res) => {
      rootReducer.dispatch(setRedirectUrl(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPaymentLink = async (orderId) => {
  const fd = new FormData();

  fd.append(
    "entity",
    JSON.stringify({ parentid: Number(orderId), parenttype: "ODR" })
  );
  fd.append("entity_type", "PMT");

  const response = await api.post(`/payment/payment-details`, fd, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data?.url;
};

export const resendCertificatePolicy = async (orderId) => {
  try {
    const fd = new FormData();
    fd.append("order_id", orderId);
    fd.append("send_email", true);

    const response = await api.post(
      "/invoice-certificate/generate-certificate",
      fd,
    );
    showToast("Certificate and policy copy resend successfully", "success");
  } catch (error) {
    const msg = error.response?.data?.error_message || "Resend failed";
    showToast(msg, "error");
  }
};

export const resendInvoice = async (orderId) => {
  try {
    const fd = new FormData();
    fd.append("order_id", orderId);
    fd.append("send_email", true);
    fd.append("type", "INVOICE");

    const response = await api.post("/invoice-certificate/generate", fd);
    showToast("Invoice resend successfully", "success");
  } catch (error) {
    const msg = error.response?.data?.error_message || "Resend failed";
    showToast(msg, "error");
  }
};


export const updateSyncInvoice = async (orderId) => {
  try {
    const fd = new FormData();
    fd.append("order_id", orderId);
    fd.append("send_email", true);
    fd.append("type", "INVOICE");

    const response = await api.post("/invoice-certificate/generate", fd);
    showToast("Invoice updated successfully", "success");
    await readData(orderId, "ODR");
    await getAllOrderDocument(orderId);
    rootReducer.dispatch(RenderPage());
    return response;
  } catch (error) {
    const msg = error.response?.data?.error_message || "Invoice update failed";
    showToast(msg, "error");
  }
};

export const updateSyncCertificate = async (orderId) => {
  try {
    const fd = new FormData();
    fd.append("order_id", orderId);
    fd.append("send_email", false);

    const response = await api.post(
      "/invoice-certificate/generate-certificate",
      fd,
      {
        params: {
          order_id: orderId,
          send_email: false,
        },
      }
    );
    showToast("Certificate updated successfully", "success");
    await readData(orderId, "ODR");
    await getAllOrderDocument(orderId);
    rootReducer.dispatch(RenderPage());
    return response;
  } catch (error) {
    const msg = error.response?.data?.error_message || "Certificate update failed";
    showToast(msg, "error");
  }
};

export const updateSyncApplicationForm = async (orderId) => {
  try {
    const response = await api.post(`/ic-report/generate/${orderId}`);
    showToast("Application form updated successfully", "success");
    await readData(orderId, "ODR");
    await getAllOrderDocument(orderId);
    rootReducer.dispatch(RenderPage());
    return response;
  } catch (error) {
    const msg = error.response?.data?.error_message || "Application form update failed";
    showToast(msg, "error");
  }
};


export const readData = (entityid, entitytype) => {
  let fd = new FormData();

  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);
  return api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      if (res?.data) {
        res.data.kyc_status = formatKycStatus(res.data);
        if (res.data.proposal_filled === 1 || res.data.proposal_filled === "1") {
          res.data.proposal_filled = "Yes";
        } else if (res.data.proposal_filled === 0 || res.data.proposal_filled === "0") {
          res.data.proposal_filled = "No";
        }
      }
      rootReducer.dispatch(setDetailsData(res.data));
      // const policyDetail = Array.isArray(res.data.Policy_detail)
      //   ? res.data.Policy_detail
      //   : res.data.Policy_detail
      //   ? [res.data.Policy_detail]
      //   : [];
      rootReducer.dispatch(updateRendererState(res.data));
      rootReducer.dispatch(setPolicyData(res.data.Policy_detail));
      rootReducer.dispatch(setTransactionData(res.data.payment_data_list));

      let targetVariantJson = res.data.variant_json;
      if (res.data.order_type === 'RENEWAL' && res.data.current_variant_json) {
        targetVariantJson = res.data.current_variant_json;
      }

      const variantJson =
        typeof targetVariantJson === "string"
          ? JSON.parse(targetVariantJson)
          : targetVariantJson;
      // rootReducer.dispatch(setProductVariantEdit(variantJson));
      rootReducer.dispatch(setProductVariantModalState(variantJson));
      if (variantJson) {
        Object.values(variantJson).forEach((obj) => {
          if (obj && obj.qualification) {
            rootReducer.dispatch(setQualification(obj.qualification));
          }
        });
      }

      // if (proposalJson) {
      //   rootReducer.dispatch(updateRendererFormState(proposalJson));
      // } else {
      //   rootReducer.dispatch(updateRendererFormState(res.data));
      // }
      // rootReducer.dispatch(setProposalJson(res.data));
      if (res.data.files) {
        rootReducer.dispatch(setInvoiceField(res.data.files.invoice));
        rootReducer.dispatch(setCertificateField(res.data.files.certificate));
      }
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const readPolicy = (entityid, entitytype) => {
  let fd = new FormData();

  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);
  return api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setPolicyData(res.data.Policy_detail));
      // rootReducer.dispatch(updateRendererFormState(selectedPolicy));
      rootReducer.dispatch(setPolicyStatus(res.data.Policy_detail.status));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getTransactionListing = (entitytype, parenttype, parentid) => {
  api
    .post(`/entity/readFromAttribute`, null, {
      params: {
        entitytype: entitytype,
        parenttype: parenttype,
        parentid: parentid,
        resolved: 0,
        attributekey: 1,
        attributevalue: 1,
      },
    })
    .then((res) => {
      rootReducer.dispatch(setTransactionData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getProductForm = async (parentId) => {
  const fd = new FormData();

  fd.append("mappedEntityType", "ATR");
  fd.append("parentType", "PPET");
  fd.append("parentId", parentId);
  api
    .post(`/agsp/getViewMasterData`, fd)
    .then((response) => {
      const productLayoutJSON =
        typeof response.data.publishedformlayout === "string"
          ? JSON.parse(response.data.publishedformlayout)
          : response.data.publishedformlayout;

      const productFieldsJSON =
        typeof response.data.publishedformfields === "string"
          ? JSON.parse(response.data.publishedformfields)
          : response.data.publishedformfields;

      rootReducer.dispatch(setProductFieldsJSON(productFieldsJSON));
      rootReducer.dispatch(setProductLayoutJSON(productLayoutJSON));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllProduct = (affinityGroupId, productType) => {
  const params = { affinityGroupId, productType };
  return api
    .get(`/product/getAllAccessibleProductForAG`, { params })
    .then((response) => {
      const customValues = Array.isArray(response?.data)
        ? response.data.map((item) => ({
          label: item.name,
          value: item.entityid,
        }))
        : [];
      rootReducer.dispatch(setProductData(response.data));
      return customValues;
    })
    .catch((error) => {
      showToast.error(
        error.response?.data?.error_message || "An error occurred",
      );
      throw error;
    });
};

export const getAllCustomer = (parentType, parentId) => {
  const params = { parentType, parentId };
  return api
    .get(`agsp/order/getAllCustomersOfAg`, { params })
    .then((response) => {
      const customValues = Array.isArray(response?.data)
        ? response.data.map((item) => ({
          label: `${item.name} (${item.email_id})`,
          value: item.entityid,
        }))
        : [];
      rootReducer.dispatch(setCustomerData(response.data));
      return customValues; // Return the mapped customer data
    })
    .catch((error) => {
      console.error("Error fetching customer data:", error);
      throw error;
    });
};

export const getAllAg = (ownerId) => {
  const params = { ownerId };
  return api
    .get(`/agsp/order/getAllAccessibleAgByOwnerId`, { params })
    .then((response) => {
      const customValues = Array.isArray(response?.data)
        ? response.data.map((item) => ({
          label: item.name,
          value: item.entityid,
        }))
        : [];
      return customValues;
    })
    .catch((error) => {
      console.error("Error fetching customer data:", error);
      throw error;
    });
};
// for additional member

export const getAdditionalMembers = async (orderId) => {
  try {
    const response = await api.get(
      `/agsp/order/getAdditionalMembersByPolicyId?policyId=${orderId}`,
    );
    const members = response.data;

    const memberData = {};
    members.forEach((member, index) => {
      const i = index + 1;
      memberData[`member_${i}_name`] = member.memberName || "";
      memberData[`member_${i}_dob`] = member.memberDob || "";
      memberData[`member_${i}_modified_date`] =
        member.modifiedDate || member.modified_date || "";

      // Store existing policycopy file keyed by just the member entityid
      if (member.policycopyMediaId && member.entityid) {
        memberData[`${member.entityid}`] = {
          media_id: member.policycopyMediaId,
          file_name: member.fileName || "policy.pdf",
          media_url: member.mediaUrl || "",
        };
      }
    });

    Object.keys(memberData).forEach((key) => {
      rootReducer.dispatch(
        setRendererFormState({ key, value: memberData[key] }),
      );
    });
    return response.data;
  } catch (error) {
    showToast(error.response?.data?.error_message, "error");
  }
};

// export const getAllProductVariant = (productId, formState) => {
//   const excludedKeys = [
//     "product_id",
//     "status",
//     "code",
//     "order_type",
//     "customer_id",
//     "emp_code",
//     "email_id",
//   ];

//   const body = Object.fromEntries(
//     Object.entries(formState).filter(([key]) => !excludedKeys.includes(key))
//   );

//   // Use the axios.post method correctly
//   api
//     .post(
//       `/dev/calc`,
//       body, // Sending body as JSON
//       {
//         params: {
//           productId,
//         },
//         headers: {
//           "Content-Type": "application/json", // Ensure Content-Type is set to JSON
//         },
//       }
//     )
//     .then((response) => {
//       const productVariants = response.data;
//       const attributeMaps = response.data.variant_json;
//       rootReducer.dispatch(setProductVariant(productVariants)); // Store all variants
//       rootReducer.dispatch(setProductVariantState(attributeMaps));
//       showToast("Product Variant created successfully..",
//         "success"
//       );
//     })
//     .catch((error) => {
//       console.log(error);
//       showToast(
//         error.response?.data?.error_message || "Error while saving..",
//         "error"
//       );
//     });
// };

const EXCLUDED_FORM_KEYS = new Set([
  "entitytype",
  "entityid",
  "status",
  "enterpriseid",
  "organizationid",
  "code",
  "seq_no",
  "created_by",
  "modified_by",
  "created_date",
  "modified_date",
  "customer_id",
  "product_id",
  "gross_amount",
  "billing_member_id",
  "billing_first_name",
  "billing_last_name",
  "billing_contact",
  "billing_email",
  "variant_json",
  "prev_order_id",
  "parent_order_id",
  "order_type",
  "proposal_form_id",
  "prev_order_code",
  "parent_order_code",
]);

const CONTAINER_ELEMENT_TYPES = new Set([
  "section",
  "fieldset",
  "column",
  "row",
]);

const getFieldValue = (vals, field) => {
  if (!vals) return undefined;
  return (
    (field.name && vals[field.name] !== undefined ? vals[field.name] : undefined) ??
    (field["database-label"] && vals[field["database-label"]] !== undefined ? vals[field["database-label"]] : undefined) ??
    (field.id && vals[field.id] !== undefined ? vals[field.id] : undefined) ??
    (field.elementid && vals[field.elementid] !== undefined ? vals[field.elementid] : undefined)
  );
};

const isFieldRequired = (field) => {
  if (
    field.required === true ||
    field.required === 1 ||
    field.required === "true"
  )
    return true;
  if (
    field["display-required"] === 1 ||
    field["display-required"] === true ||
    field["display-required"] === "1"
  )
    return true;
  if (field.rules?.required === true || field.rules?.required === 1)
    return true;
  if (
    Array.isArray(field.validations) &&
    field.validations.some(
      (v) =>
        v.type === "required" ||
        v.rule === "required" ||
        v.name === "required"
    )
  ) {
    return true;
  }
  return false;
};

const isValueFilled = (val) => {
  if (val === undefined || val === null) return false;
  if (typeof val === "boolean") return true;
  if (typeof val === "number") return !isNaN(val);
  if (typeof val === "string") return val.trim().length > 0;
  if (val instanceof File) return true;
  if (Array.isArray(val)) return val.length > 0;
  if (typeof val === "object") {
    if (Object.keys(val).length === 0) return false;
    if (
      val.file_name ||
      val.media_id ||
      val.url ||
      val.media_url ||
      val.signedUrl ||
      val.name ||
      val.path ||
      val.id ||
      val.file
    ) {
      return true;
    }
    if (val.value !== undefined && val.value !== null && val.value !== "") {
      return true;
    }
    return false;
  }
  return false;
};

const isFieldVisibleInLegacy = (field, vals) => {
  if (
    field["display-hidden"] === 1 ||
    field["display-hidden"] === true ||
    field.hidden === true
  ) {
    return false;
  }
  if (field["display-dependent"] && vals) {
    const depVal = getFieldValue(vals, {
      name: field["display-dependent"],
      "database-label": field["display-dependent"],
    });
    if (depVal === undefined || depVal === null || depVal === "") {
      return false;
    }
    if (
      field["display-index"] !== undefined &&
      Number(depVal) < Number(field["display-index"])
    ) {
      return false;
    }
  }
  if (field["parentattributekey"] && vals) {
    const parentVal = getFieldValue(vals, {
      name: field["parentattributekey"],
      "database-label": field["parentattributekey"],
    });
    if (parentVal === "no") {
      return false;
    }
  }
  return true;
};

// Legacy FormRendererV2 schema: an object map of `${elementid}-${elementtype}`
// entries carrying `display-*` keys. Kept verbatim for the orders that still
// render through the old builder.
const checkLegacyRequiredFieldsFilled = (values, fields) => {
  const fieldList = Object.values(fields);

  for (const field of fieldList) {
    if (!field) continue;
    const type = field.type || field.elementtype;
    if (type && CONTAINER_ELEMENT_TYPES.has(type.toLowerCase())) {
      continue;
    }
    if (isFieldRequired(field)) {
      if (!isFieldVisibleInLegacy(field, values)) {
        continue;
      }
      const val = getFieldValue(values, field);
      if (!isValueFilled(val)) {
        return false;
      }
    }
  }

  return true;
};

// ---------------------------------------------------------------------------
// @craft-form/renderer schema: a flat FIELDS array whose visibility is decided
// at runtime by the rules engine (ProposalRulesJSON), not by `display-*` keys.
//
// Re-deriving those conditions here is what pinned proposal_filled to 0 on
// complete forms: `dn_claidetaifany` ("Claims Details") is hidden while
// `claim` is "no", but its key still ships as "" in the record, and the legacy
// visibility check — which only understands `display-dependent` /
// `parentattributekey`, neither of which exists on a craft-form field — saw a
// required field with an empty value.
//
// So ask the renderer's own engine instead. buildRenderViewModel applies the
// rules to the field tree exactly as FormRenderer does (a hidden field comes
// back with `hide: true`, and every field component renders `null` on that),
// and applyUpdateOverrides applies the same post-rule overrides that strip
// `validation.required` off a field a rule turned optional or disabled.
// ---------------------------------------------------------------------------

// `values` is a flat denormalized record, so relation-* containers — which the
// renderer scopes into their own name space — are not walked into.
const RELATION_CONTAINER = /^relation-/;

const walkFieldTree = (nodes, visit, inheritedHidden = false) => {
  if (!Array.isArray(nodes)) return;
  for (const node of nodes) {
    if (!node || typeof node !== "object") continue;
    const hidden = inheritedHidden || node.hide === true;
    visit(node, hidden);
    if (typeof node.type === "string" && RELATION_CONTAINER.test(node.type)) {
      continue;
    }
    walkFieldTree(node.fields, visit, hidden);
    walkFieldTree(node.children, visit, hidden);
    if (Array.isArray(node.tabs)) {
      node.tabs.forEach((tab) => walkFieldTree(tab?.fields, visit, hidden));
    }
    if (Array.isArray(node.steps)) {
      node.steps.forEach((step) => walkFieldTree(step?.fields, visit, hidden));
    }
  }
};

// A hidden layout container renders none of its descendants, so their names
// count as hidden even though the field node itself carries no `hide`.
const collectHiddenLayoutNames = (layoutVM) => {
  const hidden = new Set();
  walkFieldTree(layoutVM, (node, isHidden) => {
    if (isHidden && typeof node.name === "string" && node.name) {
      hidden.add(node.name);
    }
  });
  return hidden;
};

const isRequiredAfterRules = (field) =>
  field.required === true ||
  field.validation?.required === true ||
  (typeof field.validation?.required === "string" &&
    field.validation.required.trim() !== "");

const checkCraftRequiredFieldsFilled = (values, fields, layout, rulesJson) => {
  const state = rootReducer.getState?.();
  const rawLayout = layout ?? state?.order?.ProposalLayoutJSON;
  const rules = rulesJson ?? state?.order?.ProposalRulesJSON;
  const layoutTree = rawLayout?.form?.children ?? rawLayout;

  let fieldsVM = fields;
  let layoutVM = Array.isArray(layoutTree) ? layoutTree : [];
  try {
    const vm = buildRenderViewModel({
      layout: layoutVM,
      fields,
      rulesJson: rules,
      values: values || {},
      rulesEnabled: true,
    });
    fieldsVM = vm.fieldsVM;
    layoutVM = vm.layoutVM;
  } catch (error) {
    // A malformed rules payload must not block a genuinely complete form.
    console.error("[proposal-filled] rules evaluation failed:", error);
  }

  const hiddenByLayout = collectHiddenLayoutNames(layoutVM);
  const missing = [];

  walkFieldTree(applyUpdateOverrides(fieldsVM), (field, isHidden) => {
    if (isHidden || field.disabled === true) return;
    if (typeof field.name !== "string" || !field.name) return;
    if (hiddenByLayout.has(field.name)) return;
    if (!isRequiredAfterRules(field)) return;
    if (!isValueFilled(values?.[field.name])) missing.push(field.name);
  });

  if (missing.length > 0) {
    console.warn(
      "[proposal-filled] incomplete — required fields still empty:",
      missing,
    );
  }

  return missing.length === 0;
};

/**
 * True when every field the form currently shows as required holds a value.
 * Drives `proposal_filled` (1 = complete, 0 = incomplete).
 *
 * `layout` and `rulesJson` fall back to the live redux copies, so the existing
 * two-argument callers keep working unchanged.
 */
export const checkAllRequiredFieldsFilled = (
  values,
  fields,
  layout,
  rulesJson,
) => {
  if (!fields) return true;
  return Array.isArray(fields)
    ? checkCraftRequiredFieldsFilled(values, fields, layout, rulesJson)
    : checkLegacyRequiredFieldsFilled(values, fields);
};

export const checkAllRequiredDocumentsUploaded = checkAllRequiredFieldsFilled;

const getExistingMediaId = (val) => {
  if (!val || typeof val !== "object" || Array.isArray(val)) return undefined;
  if (val instanceof File) return undefined;
  const mediaId = val.media_id ?? val.mediaId;
  if (mediaId === undefined || mediaId === null || mediaId === "") {
    return undefined;
  }
  return mediaId;
};

export const updateProposalForm = async (
  entity,
  entityid,
  entitytype,
  status,
  proposal_filled,
) => {
  // Prepare FormData
  const fd = new FormData();

  // Separate file data from other data
  const nonFileData = {};
  const fileData = {};

  Object.keys(entity).forEach((key) => {
    if (!EXCLUDED_FORM_KEYS.has(key)) {
      const val = entity[key];
      if (
        val instanceof File ||
        val?.type === "file" ||
        getExistingMediaId(val) !== undefined
      ) {
        fileData[key] = val;
      } else {
        // A relation-table row's document is a `File` nested inside this
        // value's array, which JSON.stringify would flatten to `{}` — hoist it
        // out into its own multipart part first (see Utils/craftFormFiles.js).
        nonFileData[key] = hoistNestedFiles(val, key, fileData);
      }
    }
  });

  let finalProposalFilled = proposal_filled;
  if (finalProposalFilled === 1) {
    const state = rootReducer.getState?.();
    const fields = state?.order?.ProposalFieldsJSON;
    if (!checkAllRequiredFieldsFilled(entity, fields)) {
      finalProposalFilled = 0;
    }
  }

  const formattedEntity = {
    product_proposal_form:
      Object.keys(nonFileData).length === 0
        ? null
        : JSON.stringify(nonFileData),
    // status: status || undefined,
    proposal_filled: finalProposalFilled,
  };

  // Append non-file data as JSON object
  fd.append("entity", JSON.stringify(formattedEntity));
  fd.append("entityid", entityid);
  fd.append("entitytype", entitytype);

  // Append file data separately (either as File object or existing file reference)
  Object.keys(fileData).forEach((key) => {
    const file = fileData[key];
    if (file instanceof File) {
      fd.append(key, file);
      return;
    }
    const existingMediaId = getExistingMediaId(file);
    if (existingMediaId !== undefined) {
      fd.append(key, existingMediaId);
    }
  });

  console.log("[proposal-save] file-shaped keys:", Object.keys(fileData));
  console.log(
    "[proposal-save] raw values for file-shaped keys:",
    Object.fromEntries(Object.keys(fileData).map((k) => [k, fileData[k]])),
  );
  console.log(
    "[proposal-save] FormData parts:",
    Array.from(fd.entries()).map(([k, v]) => [
      k,
      v instanceof File ? `File(${v.name})` : String(v).slice(0, 120),
    ]),
  );

  try {
    const response = await api.post(`/agsp/order/updateOrder`, fd);
    return response;
  } catch (error) {
    console.error("Error updating entity", error);
    throw error;
  }
};

export const getAllProductVariant = (productId, formState, onSuccess) => {
  const excludedKeys = [
    "product_id",
    "status",
    "code",
    "order_type",
    "customer_id",
    "emp_code",
    "email_id",
    "ag",
    "variant",
  ];
  rootReducer.dispatch(setTableLoading(true));
  const body = Object.fromEntries(
    Object.entries(formState).filter(([key]) => !excludedKeys.includes(key)),
  );

  api
    .post(`/product/getAllProductVariants`, body, {
      params: {
        productId,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const productVariants = response.data;
      const attributeMaps = response.data.variant_json;
      rootReducer.dispatch(setProductVariant(productVariants));
      rootReducer.dispatch(setProductVariantState(attributeMaps));
      rootReducer.dispatch(setTableLoading(false));

      if (onSuccess) onSuccess();
    })
    .catch((error) => {
      showToast(error?.response?.data?.error_message, "error");
      rootReducer.dispatch(setTableLoading(false));
    });
};

export const createOrder = (
  entity,
  gross_amount,
  cover_amount,
  variantJson,
  entitytype,
  navigator,
) => {
  const fd = new FormData();

  const nonFileData = {};
  const fileData = {};

  Object.keys(entity).forEach((key) => {
    // if (!excludedKeys.includes(key)) {
    if (entity[key] instanceof File) {
      // Directly use File objects for file data
      fileData[key] = entity[key];
    } else {
      nonFileData[key] = entity[key];
    }
    // }
  });

  const formattedEntity = {
    ...nonFileData,
    gross_amount: gross_amount,
    cover_amount: cover_amount,
    variant_json: JSON.stringify(variantJson),
    status: "PAYMENT_PENDING",
  };

  // Append to FormData
  fd.append("entity", JSON.stringify(formattedEntity));
  fd.append("entitytype", entitytype);
  Object.keys(fileData).forEach((key) => {
    fd.append(key, fileData[key]);
  });

  // Make the API call
  return api
    .post(`/agsp/order/createOrder`, fd)
    .then((response) => {
      rootReducer.dispatch(setCreateOrdersData(response.data));
      rootReducer.dispatch(setOrderId(response.data.entityid));
      showToast("Order created successfully", "success");
      navigator(`/order/orders/update/${response.data.entityid}`);
      return getRedirectUrl(response.data.entityid);
    })
    .catch((error) => {
      console.log(error);
      const errCode = error.response?.data?.error_code;
      if (!['ERR_022', 'ERR_023', 'ERR_024', 'ERR_025'].includes(errCode)) {
        showToast(
          error.response?.data?.error_message || "Error while creating order..",
          "error"
        );
      }
      throw error;
    });
};

// export const getAllDropdownListItems = async (
//   type,
//   productFieldsJSON,
//   parentType,
//   parentId,
//   ownerType,
//   ownerValue
// ) => {
//   const fd = new FormData();

//   fd.append("type", type);
//   fd.append("parentType", parentType);
//   fd.append("parentId", parentId);

//   if (type === "DOC") {
//     fd.append("ownerType", ownerType);
//     fd.append("ownerValue", ownerValue);
//   }

//   try {
//     const response = await api.post(
//       `/agsp/customer/getAllDropdownListItems`,
//       fd
//     );

//     if (response.data) {
//       const data = response.data;

//       if (productFieldsJSON && Object.keys(productFieldsJSON).length) {
//         const updatedProductFieldsJSON = { ...productFieldsJSON };

//         Object.keys(updatedProductFieldsJSON).forEach((key) => {
//           const field = updatedProductFieldsJSON[key];
//           if (field["data-datasourcelist"] === type) {
//             updatedProductFieldsJSON[key] = {
//               ...field,
//               "data-customvalue": data,
//             };
//           }
//         });

//         rootReducer.dispatch(setProductFieldsJSON(updatedProductFieldsJSON));
//       } else {
//         console.warn(
//           "productFieldsJSON is empty or undefined:",
//           productFieldsJSON
//         );
//       }

//       return data; // Return the data to be used in the component
//     } else {
//       console.warn("No data received in response:", response.data);
//     }
//   } catch (error) {
//     console.error("Error fetching dropdown items:", error);
//   }
// };

// export const updatePolicyForm = async (policyData) => {
//   const fd = new FormData();
//   fd.append("entity", "234567");
//   fd.append("entitytype", "PCY");
//   fd.append("entityid", policyData.entityid);
//   fd.append("applicationform_media_id", "dahsghf");
//   fd.append("policycopy_media_id", "sahgdjk");
//   try {
//     const response = await api.post(`/agsp/order/updateOrder`, fd);
//     return response.data;
//     // rootReducer.dispatch(setPolicyData(res.data.Policy_detail));
//   } catch (error) {
//     console.log("error updating policy", error);
//   }
// };

export const updatePolicy = (
  entity,
  entitytype,
  entityid,
  memberFormData = {},
) => {
  const fd = new FormData();
  const excludedKeys = ["files"];
  const nonFileData = {};
  const fileData = {};

  // Collect all member entityids so we can identify their policycopy file keys in formState
  const memberEntityIds = new Set(
    Object.values(memberFormData)
      .map((m) => String(m.entityid))
      .filter(Boolean),
  );

  const safeEntity = entity || {};
  Object.keys(safeEntity).forEach((key) => {
    if (!excludedKeys.includes(key)) {
      if (safeEntity[key] instanceof File) {
        // New file upload — send as file
        fileData[key] = safeEntity[key];
      } else if (!key.startsWith("member_") && !memberEntityIds.has(key)) {
        nonFileData[key] = safeEntity[key];
      }
    }
  });

  const membersArray = Object.keys(memberFormData).map((index) => {
    const {
      index: memberIndex,
      files,
      uploadDate,
      modifiedDate,
      modified_date,
      ...rest
    } = memberFormData[index] || {};
    return rest;
  });

  const formattedEntity = {
    ...nonFileData,
    members: membersArray,
  };

  fd.append("entity", JSON.stringify(formattedEntity));
  fd.append("entitytype", entitytype);
  fd.append("entityid", entityid);


  Object.keys(fileData).forEach((key) => {
    fd.append(key, fileData[key]);
  });

  return api
    .post(`/agsp/order/updatePolicy`, fd)
    .then(async (response) => {
      const currentState = rootReducer.getState().common.formRendererState;

      if (currentState.entityid) {
        await getAdditionalMembers(currentState.entityid);
      }

      rootReducer.dispatch(
        updateRendererFormState({
          ...currentState,
          ...response.data,
        }),
      );
      showToast("Policy updated successfully", "success");
    })
    .catch((error) => {
      console.error(error);
      showToast(
        error.response?.data?.error_message || "Error while creating order.",
        "error",
      );
    });
};

export const getProductListing = async (order_id) => {
  try {
    const response = await api.get(
      `agsp/order/getProductDetails?order_id=${order_id}`,
    );
    rootReducer.dispatch(setSelectedProductData(response.data));

    return response.data;
  } catch (error) {
    showToast(error.response?.data?.error_message, "error");
  }
};

export const getProductAttributes = async (productId) => {
  const fd = new FormData();
  fd.append("productId", productId);

  try {
    api.post(`/product/getProductFilterMeta`, fd).then((response) => {
      const data = response.data.child_product_list;

      rootReducer.dispatch(setProductAttributesData(data));

      // const parentPspOem = data.pspOem || [];
      // const childPspOem =
      //   data.child_product_list?.flatMap((child) => child.pspOem || []) || [];

      // const combinedPspOem = [...parentPspOem, ...childPspOem];

      // store.dispatch(setProductOem(combinedPspOem));
      // store.dispatch(setProductName(response.data.name));
      return data;
    });
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const uploadDocuments = async (
  entity,
  entitytype,
  entityid,
  formState,
  variant_json,
  current_variant_json,
  gross_amount,
  cover_amount,
  order_id,
  order_type,
) => {
  const fd = new FormData();

  fd.append("entitytype", entitytype);
  fd.append("entityid", entityid);

  const nonFileData = {};
  const fileData = {};

  Object.keys(formState).forEach((key) => {
    if (formState[key] instanceof File) {
      fileData[key] = formState[key];
    } else if (key === "status") {
      nonFileData[key] = formState[key];
    }
  });

  if (Object.keys(fileData).length > 0) {
    const formattedEntity = JSON.stringify({ entityid });
    fd.append("entity", formattedEntity); // Append entity with entityid
    // Append file fields separately
    Object.keys(fileData).forEach((key) => {
      fd.append(key, fileData[key]); // Append each file separately
    });
  } else {
    const isRenewal = order_type === "RENEWAL" || order_type === "RENEW";
    const entityData = {
      ...(nonFileData.status && { status: nonFileData.status }),
      // Renewals keep the original variant_json and only update current_variant_json
      ...(!isRenewal && variant_json && {
        variant_json: JSON.stringify(variant_json),
      }),
      ...(isRenewal && current_variant_json && {
        current_variant_json: JSON.stringify(current_variant_json),
      }),
      ...(gross_amount && { gross_amount }),
      ...(cover_amount && { cover_amount }),
    };
    const formattedEntity = JSON.stringify(entityData);
    fd.append("entity", formattedEntity);
  }

  try {
    const response = await api.post(`/agsp/order/updateOrder`, fd);

    if (response.status === 200) {
      showToast("Updated successfully", "success");
      rootReducer.dispatch(setIsInvoiceFileChanged(false));
      rootReducer.dispatch(setIsCertificateFileChanged(false));
      getProductListing(order_id);
      readData(order_id || entityid, "ODR");
      return response.data;
    } else {
      showToast("Something happened", "error");
    }
  } catch (error) {
    showToast(
      error.response?.data?.error_message || "Error while updating",
      "error",
    );
  }
};

export const commonDocumentUpload = async (
  mappedentitytype,
  entityType,
  mappedentityid,
  listEntityType,
) => {
  try {
    const response = await api.post(
      `/entity/getFilteredDataWithTabs/${entityType}?size=${2}&listEntityType=${listEntityType}`,
      {
        order_id: mappedentityid,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    showToast(error.response?.data?.error_message, "error");
  }
};

// export const downloadDocumentFile = async (id, filename) => {
//   try {
//     await api
//       .get(
//         `/media/downloadById/${id}`,
//         {},
//         {
//           responseType: "arraybuffer",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       )
//       .then((res) => {
//         const blob = new Blob([res.data], { type: "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);

//         var a = document.createElement("a");
//         a.href = url;
//         a.download = `${filename}`;
//         a.click();
//         window.URL.revokeObjectURL(url);
//       });
//   } catch (error) {
//     showToast(error.response?.data?.error_message, "error");
//   }
// };

// export const downloadDocumentFile = async (id, filename) => {
//   try {
//     const response = await api.get(`/media/downloadById/${id}`, {
//       responseType: "arraybuffer",
//     });

//     const blob = new Blob([response.data], {
//       type: "application/octet-stream",
//     });
//     const url = window.URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();

//     a.remove();
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     showToast(
//       error.response?.data?.error_message || "Download failed",
//       "error"
//     );
//   }
// };

export const downloadFileFromURL = (url, filename) => {
  fetch(url, {
    responseType: "blob",
  })
    .then((response) => {
      if (!response.ok) {
        console.error(`Error! Response status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename || "download";
      link.style.display = "none";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 0);
    });
};

export const getAllRelationshipManager = (customerId) => {
  const params = { customerId };
  return api
    .get(`/agsp/customer/getRMDetails`, { params })
    .then((response) => {
      // const customValues = Array.isArray(response?.data)
      //   ? response.data.map((item) => ({
      //       label: item.name,
      //       value: item.entityid,
      //     }))
      //   : response.data // Handle the single object case here
      //   ? [{ label: response.data.name, value: response.data.entityid }]
      //   : []; // Return an empty array if there's no data

      // console.log("Relationship Manager", customValues); // Log the transformed data
      rootReducer.dispatch(setRmName(response.data.name)); // Assuming you still want to store the raw response
      // return customValues; // Return the mapped customer data
    })
    .catch((error) => {
      console.error("Error fetching customer data:", error);
      // throw error; // Rethrow error for handling further up the chain
    });
};

// export const getDoctorCategory = (productId, body) => {
//   // Assuming body contains the selected options
//   const qualificationValue = body.qualification; // Extract qualification value from body
//   const requestBody = {
//     qualification: qualificationValue, // Include qualification in the request body
//     // Add other necessary parameters if needed
//   };

//   api
//     .post(`/product/getDependentAttributeValues`, requestBody, {
//       params: {
//         productId,
//       },
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//     .then((response) => {
//       // Dispatch actions to update Redux state
//       rootReducer.dispatch(setDoctorCategory(response.data));

//       // Show success toast
//     })
//     .catch((error) => {
//       console.log(error);
//       // showToast(
//       //   error.response?.data?.error_message || "Error while saving.",
//       //   "error"
//       // );
//     });
// };

export const getDependentAttributeValues = async (
  entityid,
  attributeKey,
  value,
) => {
  try {
    const response = await api.post(
      `/product/getDependentAttributeValues?productId=${entityid}`,
      { [attributeKey]: value },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.status === 200 && response) {
      rootReducer.dispatch(setDoctorCategory(response.data));
      return response.data;
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const getFormRenderer = async (productId, organizationId) => {
  const fd = new FormData();

  fd.append("parentId", productId);
  fd.append("parentType", "PPET");
  fd.append("mappedEntityType", "DPF");
  fd.append("organizationId", organizationId);

  try {
    await api.post(`/agsp/getViewMasterData`, fd).then((response) => {
      rootReducer.dispatch(setRendererFormState(response.data));
      const proposalLayoutJSON =
        typeof response.data.publishedformlayout === "string"
          ? JSON.parse(response.data.publishedformlayout)
          : response.data.publishedformlayout;

      const proposalFieldsJSON =
        typeof response.data.publishedformfields === "string"
          ? JSON.parse(response.data.publishedformfields)
          : response.data.publishedformfields;

      console.log("proposalLayoutJSON - ", proposalLayoutJSON);
      console.log("proposalFieldsJSON - ", proposalFieldsJSON);
      rootReducer.dispatch(setProposalFieldsJSON(proposalFieldsJSON));
      rootReducer.dispatch(setProposalLayoutJSON(proposalLayoutJSON));

      if (response.data?.publishedrules) {
        const rules =
          typeof response.data.publishedrules === "string"
            ? JSON.parse(response.data.publishedrules)
            : response.data.publishedrules;

        console.log(
          "response.data.publishedrules - ",
          typeof response.data.publishedrules,
        );
        console.log("rulesssss - ", typeof rules);
        console.log(Array.isArray(rules)); // true

        rootReducer.dispatch(setProposalRulesJSON(rules));
      }

      // Always dispatch (not just when truthy) so switching from a
      // new-renderer AG to an old-renderer AG within the same session
      // correctly resets this flag instead of leaving it stale — setIsNewRenderer's
      // reducer already normalizes a falsy/absent payload to false.
      rootReducer.dispatch(setIsNewRenderer(response.data?.renderer));
    });
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const getAllOrderDocument = async (orderid) => {
  const fd = new FormData();

  fd.append("orderId", orderid);
  try {
    const response = await api.post("/agsp/order/getAllDocumentsForOrder", fd);
    if (response && response.status === 200) {
      rootReducer.dispatch(setGetAllOrderDocuments(response.data));
      return response.data;
    }
  } catch (error) {
    console.log("Error getting Order documents", error);
  }
};

export const saveManualPaymentMode = async (entity, entityid) => {
  const fd = new FormData();

  const nonFileData = {};
  const fileData = {};

  Object.keys(entity).forEach((key) => {
    const value = entity[key];
    if (value instanceof File || (value?.type && value?.name)) {
      fileData[key] = value; // Ensure it's a File or file-like object
    } else {
      nonFileData[key] = value;
    }
  });
  // const { entityid, file, ...rest } = entity;

  console.log(entity);

  const formattedEntity = JSON.stringify(nonFileData);

  // Append non-file data as JSON object
  fd.append("entity", formattedEntity);
  fd.append("entity_type", "PMT");
  if (entityid) {
    fd.append("entity_id", entityid);
  }

  // Append file data separately (either as File object or existing file reference)
  Object.keys(fileData).forEach((key) => {
    fd.append(key, fileData[key]);
  });

  let response;
  try {
    response = await api.post(`/payment/manualPayment`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response && response.status === 200) {
      // rootReducer.dispatch(setManualPaymentDetails(response.data));
      rootReducer.dispatch(RenderPage());
      return response.data;
    }
  } catch (error) {
    console.log("Error in saving manual payment", error);
    toast.error("Error");
  }
};

export const updateManualPaymentMode = async (
  updatedEntity,
  entityid,
  entityType,
  payment_slip_media_id,
) => {
  let fd = new FormData();

  const { parentid, parenttype, ...filteredEntity } = updatedEntity;

  fd.append("entity", JSON.stringify(filteredEntity));
  fd.append("entityid", entityid);
  fd.append("entitytype", entityType);
  fd.append("payment_slip_media_id", payment_slip_media_id);

  try {
    const response = await api.post(`/agsp/update`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response && response.status === 200) {
      rootReducer.dispatch(RenderPage());
      return response.data;
    }
  } catch (error) {
    console.log("Error in saving manual payment", error);
  }
};

export const updateManualPaymentById = async (id, entitytype) => {
  try {
    const response = await api.post(
      `/entity/read?entityid=${id}&entitytype=${entitytype}`,
    );
    if (response.data) {
      rootReducer.dispatch(setManualPaymentDetails(response.data));
      rootReducer.dispatch(updateRendererFormState(response.data));
      rootReducer.dispatch(RenderPage());
      return response.data;
    }
  } catch (error) {
    console.log("Error", error);
  }
};

export const getRMList = () => {
  api
    .get(`/agsp/customer/getRmList`, null)
    .then((res) => {
      rootReducer.dispatch(setRmData(res.data));
    })
    .catch((err) => {
      showToast(
        err.response?.data?.error_message || "An error occurred",
        "error",
      );
    });
};

export const readPrposalData = (orderId, displayMode, organizationId) => {
  let fd = new FormData();

  fd.append("orderId", orderId);
  fd.append("displayMode", displayMode);
  fd.append("organizationId", organizationId);

  api
    .post(`/agsp/order/getProposalFormData`, fd, {})
    .then((res) => {
      rootReducer.dispatch(updateRendererState(res.data));
      rootReducer.dispatch(setProposalJson(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

// react-query variant of readPrposalData: returns the fetched data instead of
// dispatching to redux, so callers can manage it via useQuery's own cache.
export const fetchProposalFormData = async (
  orderId,
  displayMode,
  organizationId,
) => {
  let fd = new FormData();

  fd.append("orderId", orderId);
  fd.append("displayMode", displayMode);
  fd.append("organizationId", organizationId);

  const res = await api.post(`/agsp/order/getProposalFormData`, fd, {});
  return res.data;
};


export const fetchProposalDropdownOptions = async ({
  type,
  agId,
  ownerType,
  ownerValue,
}) => {
  if (agId === undefined || agId === null) {
    // Fails loud instead of silently posting parentId="undefined" to the
    // backend — @craft-form/renderer catches this per-field (errorByTargetId)
    // rather than crashing the form, so throwing here is safe.
    throw new Error(
      `fetchProposalDropdownOptions: missing agId while fetching options for "${type}"`,
    );
  }

  let fd = new FormData();

  fd.append("type", type);
  fd.append("parentType", "AGRP");
  fd.append("parentId", agId);

  if (ownerType && ownerValue !== undefined && ownerValue !== null) {
    fd.append("ownerType", ownerType);
    fd.append("ownerValue", ownerValue);
  }

  const res = await api.post(`agsp/customer/getAllDropdownListItems`, fd);
  const data = res.data;

  // Normalizes to @craft-form/renderer's Option shape ({ label, value }) —
  // same fallback chain CustomSelect.jsx uses for this endpoint's raw rows,
  // since the backend response isn't already { label, value } pairs.
  if (!Array.isArray(data)) {
    console.warn(
      `fetchProposalDropdownOptions: unexpected response for "${type}"`,
      data,
    );
    return [];
  }

  return data.map((item) => ({
    value: item.value ?? item.key,
    label: item.label ?? item.value ?? item.key,
  }));
};

export const renewOrder = (orderId, isRenewal) => {
  let fd = new FormData();

  fd.append("orderId", orderId);
  fd.append("isRenewal", isRenewal);

  return api
    .post(`agsp/order/createRenewalOrder`, fd, {})
    .then((res) => {
      showToast("Order renewed successfully", "success");
      return res;
    })
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

// export const updateOrder = (orderId, memberId) => {
//   let fd = new FormData();
//   fd.append("orderId", orderId);
//   fd.append("memberId", memberId);

//   api
//     .post(`agsp/order/updateAgMemberForOrder`, fd, {})
//     .then((res) => {
//       if (res.status === 200) {
//         readData(orderId, "ODR");
//       }
//       showToast("Order updated successfully", "success");
//     })
//     .catch((err) => {
//       console.log(err);
//       showToast(err?.response?.data?.error_message, "error");
//     });
// };
export const updateOrder = (orderId, memberId) => {
  let fd = new FormData();
  fd.append("orderId", orderId);
  fd.append("memberId", memberId);

  return api
    .post(`agsp/order/updateAgMemberForOrder`, fd, {})
    .then((res) => {
      if (res.status === 200) {
        readData(orderId, "ODR"); // This will now be called after await
      }
      showToast("Order updated successfully", "success");
      return res;
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};

export const updateStatusOrder = (entitytype, entityid, entity) => {
  let fd = new FormData();
  fd.append("entitytype", entitytype);
  fd.append("entityid", entityid);
  fd.append("entity", JSON.stringify(entity));

  api
    .post(`/agsp/order/updateOrder`, fd, {})
    .then((res) => {
      if (res.status === 200) {
        readData(entityid, "ODR");
      }
      showToast("Order updated successfully", "success");
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};

export const deleteOrder = (orderId) => {
  let fd = new FormData();

  fd.append("orderId", orderId);
  api
    .post(`agsp/order/deleteOrder`, fd, {})
    .then((res) => {
      showToast("Order deleted successfully", "success");
      rootReducer.dispatch(RenderPage());
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};


export const getChildAttributeValue = async (attributeId, parentValue) => {
  try {
    const response = await api.get(
      `/product/getChildAttributeValue?attributeId=${attributeId}&parentValue=${parentValue}`,
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const uploadCkycDocuments = async (memberId, orderId, files) => {
  const toBase64 = f => new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(f);
  });

  const payload = {
    member_id: Number(memberId),
    order_id: Number(orderId),
    ckyc_aadhaar: files.aadhaar ? await toBase64(files.aadhaar) : undefined,
    ckyc_pan: files.pan ? await toBase64(files.pan) : undefined,
  };

  return api.post(`/ckyc/member/upload-doc`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 180000,
  });
};

export const verifyCkycNumber = async (payload) => {
  return api.post(`/ckyc/member/verify`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getCkycStatus = async (memberId, orderId) => {
  return api.post(`/ckyc/member/status`, null, {
    params: { member_id: memberId, order_id: orderId },
  });
};

/**
 * The cr_event_log source values the order Event tab can ask for. They match the source column the
 * backend writes verbatim. Adding another integration to the tab is one more entry here, no
 * backend change.
 */
export const EVENT_SOURCE = {
  SIBRO: "SIBRO",
  CKYC: "CKYC",
};

/**
 * The event trail for one order, newest first, limited to the sources asked for. The list is sent
 * by the caller rather than fixed on the server, so the tab decides which trails it shows - all of
 * them, or one at a time - without another API change.
 *
 * Returns an empty list on failure rather than throwing - the tab is an audit view, so a failed
 * fetch should show the user nothing to read, not break the order screen around it.
 */
export const getOrderEventLogs = async (
  orderId,
  sources = [EVENT_SOURCE.SIBRO, EVENT_SOURCE.CKYC],
) => {
  try {
    // The api instance defaults to multipart/form-data; this body is JSON and the source list has
    // to arrive as a JSON array, so the header is set here rather than left to the default.
    const response = await api.post(
      `sibro/eventLogs/order`,
      { orderId, sources },
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data || [];
  } catch (error) {
    showToast(
      error?.response?.data?.error_message || "Could not load order activity",
      "error",
    );
    return [];
  }
};

/**
 * Reads which CKYC journeys the backend has enabled.
 * Response: { upload_doc_enabled: boolean, verify_enabled: boolean }
 * Auth header is attached by the shared api interceptor, same as /ckyc/member/*.
 */
export const getCkycFlows = async () => {
  return api.get(`/ckyc/flows`);
};
